<section class="py-7 section-content bg-light">
  <div class="container-xl">
    <h2 class="h3 text-center mb-5">Customers Reviews</h2>
    <div class="row g-4">
      <div class="col-12 col-md-6">
        <div class="testimonial bg-white p-3 p-md-5 h-100 d-flex flex-column d-flex flex-column">
          <p>
            "We would love to partner with you again, having personally stayed at Vidanta Nuevo Vallarta I can stand
            behind the luxury of these resorts”
          </p>
          <h3 class="h5 mt-auto mb-0">Charlotte's Wings</h3>
          <ul class="rating-list text-primary mt-4 list-unstyled d-flex align-items-center mb-0">
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="testimonial bg-white p-3 p-md-5 h-100 d-flex flex-column">
          <p>
            ....this was our biggest income generator outside of big sponsorships so a HUGE thank you to Charity Booster
          </p>
          <h3 class="h5 mt-auto mb-0">Claudia</h3>
          <p class="fs-sm mb-0">Youth Tennis Advantage</p>
          <ul class="rating-list text-primary mt-4 list-unstyled d-flex align-items-center mb-0">
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div class="testimonial bg-white p-3 p-md-5 h-100 d-flex flex-column">
          <p>
            "Your client is in great hands with Charity Booster. Clients and winning bidders all have given great
            feedback!”
          </p>
          <h3 class="h5 mt-auto mb-0">Benjamin Farrell</h3>
          <p class="fs-sm mb-0">Custom Benefits Auctions</p>
          <ul class="rating-list text-primary mt-4 list-unstyled d-flex align-items-center mb-0">
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="testimonial bg-white p-3 p-md-5 h-100 d-flex flex-column">
          <p>
            I am booking a vacation for October. I want to share how your booking team has gone above and beyond to help
            me book my travel.
          </p>
          <h3 class="h5 mt-auto mb-0">Lisa Knatvold</h3>
          <p class="fs-sm mb-0">American Fidelity</p>
          <ul class="rating-list text-primary mt-4 list-unstyled d-flex align-items-center mb-0">
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="testimonial bg-white p-3 p-md-5 h-100 d-flex flex-column">
          <p>This package raised an enormous amount of funds for life-saving research...we can’t thank you enough!</p>
          <h3 class="h5 mt-auto mb-0">Julie Davidson</h3>
          <p class="fs-sm mb-0">The Leukemia & Lymphoma Society</p>
          <ul class="rating-list text-primary mt-4 list-unstyled d-flex align-items-center mb-0">
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
            <li class="rating-item d-flex">
              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.953 6.905a.955.955 0 00-.823-.658l-5.196-.472L9.88.967a.957.957 0 00-1.76 0L6.066 5.776.87 6.247A.957.957 0 00.327 7.92l3.927 3.444-1.158 5.101A.956.956 0 004.519 17.5L9 14.82l4.48 2.679a.957.957 0 001.424-1.034l-1.159-5.101 3.928-3.443a.957.957 0 00.28-1.017z"
                  fill="currentColor"
                />
              </svg>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
